export default __webpack_public_path__ + "static/media/1-removebg-preview.d9335637.png";